export default __webpack_public_path__ + "media/music/185d01eabe5ccd3076c61bb7bb7366aa.mp3";